export default __webpack_public_path__ + "static/media/preloader2.31518111.gif";